import {
  Alert,
  CircularProgress,
  MenuItem,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useSnackbar } from 'notistack';

import { useAdminRequests, usePatchRequest } from '../../api/queries';
import { shortDate } from '../../lib/format';

const STATUSES = ['drafted', 'submitted', 'fulfilled', 'denied'];

export default function AdminRequests() {
  const { data, isLoading, error } = useAdminRequests();
  const patch = usePatchRequest();
  const { enqueueSnackbar } = useSnackbar();

  if (isLoading) return <CircularProgress />;
  if (error) return <Alert severity="error">Failed: {String(error)}</Alert>;

  const setStatus = async (id: string, status: string) => {
    try {
      await patch.mutateAsync({ id, status });
      enqueueSnackbar('Status updated', { variant: 'success' });
    } catch (err) {
      enqueueSnackbar(`Update failed: ${err instanceof Error ? err.message : err}`, {
        variant: 'error',
      });
    }
  };

  return (
    <Stack spacing={2}>
      {data && data.length > 0 ? (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Request ID</TableCell>
              <TableCell>Requester</TableCell>
              <TableCell>App</TableCell>
              <TableCell>Manager</TableCell>
              <TableCell>Justification</TableCell>
              <TableCell>Created</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((r) => (
              <TableRow key={r.id} hover>
                <TableCell title={r.id} className="font-mono">
                  {r.id.slice(0, 8)}
                </TableCell>
                <TableCell>{r.requester_email}</TableCell>
                <TableCell>{r.app_name}</TableCell>
                <TableCell>{r.manager_email ?? '—'}</TableCell>
                <TableCell className="max-w-xs truncate">{r.justification ?? '—'}</TableCell>
                <TableCell>{shortDate(r.created_at)}</TableCell>
                <TableCell>
                  <Select
                    size="small"
                    value={r.status}
                    onChange={(e) => setStatus(r.id, e.target.value)}
                  >
                    {STATUSES.map((s) => (
                      <MenuItem key={s} value={s}>
                        {s}
                      </MenuItem>
                    ))}
                  </Select>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      ) : (
        <Typography color="text.secondary">No requests yet.</Typography>
      )}
    </Stack>
  );
}
